<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user
          :campaign-id="campaignId"
          :user-status="user_status"
          @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout"
          @show-confirmation="showConfirmation"
          @current-user="handleCurrentUser"
          :custom-css="customCssUrl"
          :language="$t('Language')"
        ></snipp-current-user>
      </div>
      <div id="registration-wrapper" v-if="registration_enabled">
        <snipp-registration
          app-source="CampaignWidget"
          refresh-reload="true"
          :campaign-id="campaignId"
          :show-confirmation="show_confirmation"
          :custom-css="customCssUrl"
          :is-logged-out="is_logged_out"
          @is-registered="handleIsRegistered"
          :language="$t('Language')"
        ></snipp-registration>
      </div>
      <div id="thanks-text" v-if="show_thanks" class="thanks-container-inline text-center">
        <!-- Confetti Background Layer -->
        <div class="confetti-background">
          <div v-for="i in 30" :key="i" :class="['confetti-piece', `piece-${i}`, getShapeClass(i), getColorClass(i)]"></div>
        </div>

        <div class="thanks-content-card">
          <h1 class="thanks-title" v-html="$t('Thanks.Title')"></h1>
          <h2 class="thanks-subtitle" v-html="$t('Thanks.Subtitle')"></h2>
          
          <p class="thanks-desc" v-html="formattedDescription"></p>
          
          <p class="thanks-footnote" v-html="formattedSubtext"></p>

          <div class="btn-container mt-4">
            <router-link to="/Prizes-Stacked" class="btn btn-explore-prizes">
              {{ $t('Thanks.ExplorePrizesBtn') }}
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div id="upload-wrapper" v-if="upload_enabled">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <h2 class="text-center my-4">
            {{ $t('IPEwidget.UploadReceiptTitle') }}
          </h2>
          <div v-html="$t('IPEwidget.ImageUploadDesc1')"></div>
          <p class="">{{ $t('IPEwidget.ImageUploadDesc2') }}</p>
          <div class="mt-4">
            <snipp-upload
              :campaign-id="campaignId"
              include-upload-button="true"
              @snipp-upload-result="handleSnippUploadResult"
              :custom-css="customCssUrl"
              :language="$t('Language')"
            ></snipp-upload>
          </div>
          <p
            class="my-4 text-center"
            v-html="$t('IPEwidget.ImageUplaodInstruction')"
          ></p>
        </div>
        <div id="upload-again" v-if="upload_enabled === 'upload_again'">
          <snipp-upload
            :campaign-id="campaignId"
            include-upload-again-button="true"
            @snipp-upload-result="handleSnippUploadResult"
            :custom-css="customCssUrl"
            :language="$t('Language')"
          ></snipp-upload>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
      show_thanks: true, // 👈 TEMPORARILY TRUE FOR PREVIEW
    };
  },
  computed: {
    customCssUrl() {
      return window.location.origin + '/assets/css/custom_overrides.css';
    },
    formattedDescription() {
      return this.$t('Thanks.Description');
    },
    formattedSubtext() {
      const rulesText = this.$t('Thanks.RulesLinkText');
      const rulesLink = `<a href="https://www.snipp.com/terms-and-conditions" target="_blank" class="official-rules-link">${rulesText}</a>`;
      return this.$t('Thanks.Subtext', { rules: rulesLink });
    }
  },
  methods: {
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.show_thanks = false;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.registration_enabled = false;
      this.show_thanks = true; // 👈 show thanks instead
    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.show_thanks = true; // 👈 show thanks instead
    },
    getShapeClass(index) {
      const shapes = ['triangle', 'rect', 'circle', 'oval', 'rect', 'triangle', 'oval'];
      return 'shape-' + shapes[index % shapes.length];
    },
    getColorClass(index) {
      const colors = ['cyan', 'yellow', 'pink', 'blue', 'teal', 'pink', 'yellow'];
      return 'color-' + colors[index % colors.length];
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },
};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}
.color-red {
  color: #bf233a;
}
#current-user-wrapper,
#upload-wrapper {
  max-width: 70%;
  margin: 0 auto;
}
@media screen and (max-width: 575px) {
  #current-user-wrapper,
  #upload-wrapper {
    max-width: 100%;
    margin: 0 auto;
  }
}

/* Inline Thanks Custom Design */
.thanks-container-inline {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  padding: 3rem 1.5rem;
  overflow: hidden;
  border-radius: 12px;
  min-height: 480px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Confetti System */
.thanks-container-inline .confetti-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.thanks-container-inline .confetti-piece {
  position: absolute;
  opacity: 0.85;
  will-change: transform;
}

/* Confetti Shapes */
.thanks-container-inline .shape-rect {
  width: 14px;
  height: 7px;
}

.thanks-container-inline .shape-triangle {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 12px solid currentColor;
  background: transparent !important;
}

.thanks-container-inline .shape-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.thanks-container-inline .shape-oval {
  width: 14px;
  height: 8px;
  border-radius: 50%;
}

/* Confetti Colors */
.thanks-container-inline .color-cyan {
  color: #00b8f1;
  background-color: #00b8f1;
}
.thanks-container-inline .shape-triangle.color-cyan {
  border-bottom-color: #00b8f1;
}

.thanks-container-inline .color-yellow {
  color: #fbe63d;
  background-color: #fbe63d;
}
.thanks-container-inline .shape-triangle.color-yellow {
  border-bottom-color: #fbe63d;
}

.thanks-container-inline .color-pink {
  color: #f4306c;
  background-color: #f4306c;
}
.thanks-container-inline .shape-triangle.color-pink {
  border-bottom-color: #f4306c;
}

.thanks-container-inline .color-blue {
  color: #2584C5;
  background-color: #2584C5;
}
.thanks-container-inline .shape-triangle.color-blue {
  border-bottom-color: #2584C5;
}

.thanks-container-inline .color-teal {
  color: #00c2a8;
  background-color: #00c2a8;
}
.thanks-container-inline .shape-triangle.color-teal {
  border-bottom-color: #00c2a8;
}

/* Confetti Animations */
@keyframes float-drift-inline-1 {
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(45deg); }
  100% { transform: translateY(0px) rotate(0deg); }
}

@keyframes float-drift-inline-2 {
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-15px) rotate(-60deg); }
  100% { transform: translateY(0px) rotate(0deg); }
}

@keyframes float-drift-inline-3 {
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-8px) rotate(90deg); }
  100% { transform: translateY(0px) rotate(0deg); }
}

/* Distribution */
.thanks-container-inline .piece-1 { left: 4%; top: 8%; transform: rotate(15deg); animation: float-drift-inline-1 5s ease-in-out infinite; }
.thanks-container-inline .piece-2 { left: 12%; top: 22%; transform: rotate(45deg); animation: float-drift-inline-2 6s ease-in-out infinite; }
.thanks-container-inline .piece-3 { left: 7%; top: 40%; transform: rotate(-25deg); animation: float-drift-inline-3 7s ease-in-out infinite; }
.thanks-container-inline .piece-4 { left: 14%; top: 58%; transform: rotate(35deg); animation: float-drift-inline-1 4.5s ease-in-out infinite; }
.thanks-container-inline .piece-5 { left: 5%; top: 72%; transform: rotate(80deg); animation: float-drift-inline-2 8s ease-in-out infinite; }
.thanks-container-inline .piece-6 { left: 16%; top: 84%; transform: rotate(-15deg); animation: float-drift-inline-3 6.5s ease-in-out infinite; }

.thanks-container-inline .piece-7 { right: 4%; top: 12%; transform: rotate(50deg); animation: float-drift-inline-2 7s ease-in-out infinite; }
.thanks-container-inline .piece-8 { right: 9%; top: 26%; transform: rotate(-30deg); animation: float-drift-inline-1 5.5s ease-in-out infinite; }
.thanks-container-inline .piece-9 { right: 6%; top: 46%; transform: rotate(10deg); animation: float-drift-inline-3 8s ease-in-out infinite; }
.thanks-container-inline .piece-10 { right: 13%; top: 62%; transform: rotate(-45deg); animation: float-drift-inline-2 6.5s ease-in-out infinite; }
.thanks-container-inline .piece-11 { right: 7%; top: 76%; transform: rotate(20deg); animation: float-drift-inline-1 7.5s ease-in-out infinite; }
.thanks-container-inline .piece-12 { right: 15%; top: 88%; transform: rotate(-80deg); animation: float-drift-inline-3 5.5s ease-in-out infinite; }

.thanks-container-inline .piece-13 { left: 24%; top: 7%; transform: rotate(60deg); animation: float-drift-inline-3 8s ease-in-out infinite; }
.thanks-container-inline .piece-14 { left: 44%; top: 4%; transform: rotate(-10deg); animation: float-drift-inline-2 5.5s ease-in-out infinite; }
.thanks-container-inline .piece-15 { left: 64%; top: 6%; transform: rotate(35deg); animation: float-drift-inline-1 7.5s ease-in-out infinite; }
.thanks-container-inline .piece-16 { left: 78%; top: 8%; transform: rotate(-50deg); animation: float-drift-inline-3 6.5s ease-in-out infinite; }

.thanks-container-inline .piece-17 { left: 28%; top: 88%; transform: rotate(-35deg); animation: float-drift-inline-1 6.5s ease-in-out infinite; }
.thanks-container-inline .piece-18 { left: 48%; top: 90%; transform: rotate(40deg); animation: float-drift-inline-3 7.5s ease-in-out infinite; }
.thanks-container-inline .piece-19 { left: 68%; top: 87%; transform: rotate(-15deg); animation: float-drift-inline-2 8.5s ease-in-out infinite; }

.thanks-container-inline .piece-20 { left: 21%; top: 34%; transform: rotate(120deg); animation: float-drift-inline-1 7s ease-in-out infinite; }
.thanks-container-inline .piece-21 { left: 25%; top: 64%; transform: rotate(-75deg); animation: float-drift-inline-2 6s ease-in-out infinite; }
.thanks-container-inline .piece-22 { right: 22%; top: 36%; transform: rotate(85deg); animation: float-drift-inline-3 8s ease-in-out infinite; }
.thanks-container-inline .piece-23 { right: 26%; top: 68%; transform: rotate(-110deg); animation: float-drift-inline-1 6.5s ease-in-out infinite; }

.thanks-container-inline .piece-24 { left: 32%; top: 18%; transform: rotate(15deg); opacity: 0.6; animation: float-drift-inline-2 7.5s ease-in-out infinite; }
.thanks-container-inline .piece-25 { right: 32%; top: 20%; transform: rotate(-45deg); opacity: 0.6; animation: float-drift-inline-1 8.5s ease-in-out infinite; }
.thanks-container-inline .piece-26 { left: 35%; top: 76%; transform: rotate(-85deg); opacity: 0.6; animation: float-drift-inline-3 6.5s ease-in-out infinite; }
.thanks-container-inline .piece-27 { right: 35%; top: 74%; transform: rotate(125deg); opacity: 0.6; animation: float-drift-inline-2 8s ease-in-out infinite; }

.thanks-container-inline .piece-28 { left: 9%; top: 4%; transform: rotate(95deg); animation: float-drift-inline-1 5.5s ease-in-out infinite; }
.thanks-container-inline .piece-29 { right: 11%; top: 5%; transform: rotate(-65deg); animation: float-drift-inline-3 6.5s ease-in-out infinite; }
.thanks-container-inline .piece-30 { left: 54%; top: 85%; transform: rotate(30deg); animation: float-drift-inline-2 7s ease-in-out infinite; }

/* Card Content Styling */
.thanks-content-card {
  position: relative;
  z-index: 10;
  max-width: 680px;
  padding: 1.5rem 1rem;
}

.thanks-title {
  font-family: "Roboto", sans-serif;
  font-size: 2.85rem;
  font-weight: 700;
  color: #000000;
  margin-top: 0;
  margin-bottom: 1.25rem;
  line-height: 1.15;
}

.thanks-subtitle {
  font-family: "Roboto", sans-serif;
  font-size: 1.45rem;
  font-weight: 400;
  color: #000000;
  margin-bottom: 1.75rem;
  line-height: 1.3;
}

.thanks-desc {
  font-family: "Roboto", sans-serif;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #000000;
  max-width: 600px;
  margin: 0 auto 1.75rem;
}

.thanks-footnote {
  font-family: "Roboto", sans-serif;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #000000;
  max-width: 540px;
  margin: 0 auto 2.25rem;
}

:deep(.official-rules-link) {
  color: #2584C5 !important;
  text-decoration: underline !important;
  font-weight: 400;
  transition: color 0.2s ease;
}

:deep(.official-rules-link:hover) {
  color: #1b6ca2 !important;
}

/* Explore Prizes Button */
.btn-explore-prizes {
  display: inline-block;
  background-color: #2584C5;
  color: #ffffff !important;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0.8rem 4.5rem;
  border-radius: 8px;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(37, 132, 197, 0.2);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: none;
}

.btn-explore-prizes:hover {
  background-color: #1b6ca2;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(37, 132, 197, 0.35);
}

.btn-explore-prizes:active {
  transform: translateY(0);
}

@media screen and (max-width: 767px) {
  .thanks-container-inline {
    padding: 2rem 0.75rem;
    min-height: 420px;
  }
  .thanks-title {
    font-size: 2.15rem;
  }
  .thanks-subtitle {
    font-size: 1.15rem;
  }
  .thanks-desc {
    font-size: 0.95rem;
  }
  .thanks-footnote {
    font-size: 0.8rem;
  }
  .btn-explore-prizes {
    width: 100%;
    max-width: 280px;
    padding: 0.8rem 2rem;
  }
  
  /* Hide excessive confetti for smaller viewports */
  .thanks-container-inline .piece-20,
  .thanks-container-inline .piece-21,
  .thanks-container-inline .piece-22,
  .thanks-container-inline .piece-23,
  .thanks-container-inline .piece-24,
  .thanks-container-inline .piece-25,
  .thanks-container-inline .piece-26,
  .thanks-container-inline .piece-27,
  .thanks-container-inline .piece-28,
  .thanks-container-inline .piece-29,
  .thanks-container-inline .piece-30 {
    display: none;
  }
}
</style>
